

<!-- <div class="container position-relative">

<div class="py-5  row">
<div class="col-md-6 ml-auto mr-auto">
    <div class="px-5 col-10 mx-auto " >
    <h2 class="text-dark my-0">Welcome Back</h2>
    <p class="text-50">Sign in to continue</p>
    <form class="mt-5 mb-4" action="verification.html">
    <div class="form-group">
    <label for="exampleInputEmail1" class="text-dark">Email</label>
    <input type="email"  placeholder="Enter Email" class="form-control" id="email" name="email"  [(ngModel)]="email" aria-describedby="emailHelp">
    <div *ngIf="submited && email==''" 
    ><label class="validate-error"> Email required</label></div>
    
    <div *ngIf="submited && email!='' && !validateEmail(email) " 
    ><label class="validate-error"> Invalid  Email</label></div>    

</div>
    <div class="form-group">
    <label for="exampleInputPassword1" class="text-dark">Password</label>
    <input type="password" placeholder="Enter Password"  name="password"  [(ngModel)]="password" class="form-control" id="password">
    <div *ngIf="submited && password==''" 
                 ><label class="validate-error"> password required</label></div>
</div>
    <button class="btn btn-primary btn-lg btn-block" (click)="loginClick()">SIGN IN</button>
  
    </form>
    <a href="forgot_password.html" class="text-decoration-none">
    <p class="text-center">Forgot your password?</p>
    </a>
   
    </div>
    </div>
</div>
</div> -->

<!-- <div class="container-fluid">
    <div class="row">
        <div class="col-md-9"></div>
        <div class="col-md-3">
            <div class="card">
                <div class="card-body">
                    <div class="row" style="margin-right: 0px;margin-top: 40%;">
                        <div class="col-md-12">
                        <h1 class="">Welcome Back</h1>
                        </div>
                        <div class="col-md-12">
                        <h5 class="" style="color:#909090;">Sign in to continue.</h5>
                        </div>
                        <form  action="verification.html" style="width: 100%;">
                        <div class="col-md-12">
                    <label class="pt-5">User Name</label></div>
                    <div class="col-md-12">
                    <input type="email" class="form-control"  placeholder="Enter Email" id="email" name ="email" [(ngModel)]="email" aria-describedby="emailHelp" autocomplete="off">
                    <div *ngIf="submited && email==''" 
                    ><label class="validate-error"> Email required</label></div>
                    <div *ngIf="submited && email!='' && !validateEmail(email)"><label class="validate-error"> Invalid  Email</label></div>    
                    </div>
                    <div class="col-md-4"></div>
                    <div class="col-md-12">
                    <label class="pt-3">Password</label></div>
                    <div class="col-md-12 mb-3">
                        <input type="password" placeholder="Enter Password"  name="password"  [(ngModel)]="password" class="form-control" id="password" autocomplete="off">
                        <div *ngIf="submited && password==''"><label class="validate-error"> password required</label></div>
                    </div>
                    <div class="col-md-12 text-center pt-4">
                        <button type="button" id="btnLogin" class="btn btn-primary btn-lg btn-block btn-uppercase mb-4 waves-effect waves-button waves-light" style="justify-content: center;
                        height: 50px;border-radius: 15px;" (click)="loginClick()">Sign In</button>
                    </div>
                    </form>
                    <div class="col-md-12">
                        <a href="forgot_password.html" class="text-decoration-none" style="float:right;">
                            <p class="text-center">Forgot your password?</p>
                            </a>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->


<section class="vh-100" alt="#" id="imgLoginBg" name="imgLoginBg">
  <div class="container py-5 h-100">
    <div class="row d-flex justify-content-center align-items-center h-100">
      <div class="col col-xl-10">
        <div class="card" style="border-radius: 1rem;">
          <div class="row g-0">
            <div class="col-md-7 col-lg-5 d-none d-md-block">
              <img alt="#" id="imgLogin" name="imgLogin" class="img-fluid" style="border-radius: 1rem 0 0 1rem;height: 100%;" />
            </div>
            <div class="col-md-5 col-lg-7 d-flex align-items-center">
              <div class="card-body p-4 p-lg-5 text-black">

                <form action="verification.html" style="width: 100%;">
                  <a class="cursor-pointer" (click)="homeClick()"><i class="feather-home mr-2" style="font-size:25px;color:#f00;"></i>Back to Home.</a>

                  <div class="d-flex align-items-center mb-3 pb-1 mt-2">
                    <i class="fas fa-cubes fa-2x me-3" style="color: #ff6219;"></i>
                    <span class="h1 fw-bold mb-0">Welcome Back</span>
                  </div>

                  <h5 class="fw-normal mb-3 pb-3" style="letter-spacing: 1px;">Sign in to continue</h5>

                  <div class="form-outline mb-4">
                      <label class="form-label" for="form2Example17">Email address</label>
                      <input type="email" class="form-control form-control-lg"  placeholder="Enter Email" id="email" name ="email" [(ngModel)]="email" aria-describedby="emailHelp" autocomplete="off">
                      <div *ngIf="submited && email==''" 
                      ><label class="validate-error"> Email required</label></div>
                      <div *ngIf="submited && email!='' && !validateEmail(email)"><label class="validate-error"> Invalid  Email</label></div>
                  </div>

                  <div class="form-outline mb-4">
                      <label class="form-label" for="form2Example27">Password</label>
                      <input type="password" placeholder="Enter Password"  name="password"  [(ngModel)]="password" class="form-control form-control-lg" id="password" autocomplete="off">
                      <div *ngIf="submited && password==''"><label class="validate-error"> password required</label></div>
                  </div>

                  <div class="pt-1 mb-4">
                    <button id="btnLogin" class="btn btn-primary btn-lg btn-block btn-uppercase mb-4 waves-effect waves-button waves-light" type="button" (click)="loginClick()">Sign In</button>
                  </div>
                  <div class="row">
                    <div class="col-md-8">
                      <p class="text-left cursor-pointer"  (click)="registrationClick()" style="color:#000;">Don't have an account? Register here</p>
                    </div>
                    <div class="col-md-4">
                      <a class="text-muted" data-toggle="modal" data-target="#forogtpassword" (click)="forgotPasswordClick()" style="float:right;cursor:pointer;">Forgot password?</a>
                    </div>
                  </div>
                
                  <p class="text-center cursor-pointer mt-3"  (click)="guestLoginClick()" style="font-size:18px;color:#000;">Login as a Guest User.</p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


  <!-- modal popup start -->
<div class="modal"  [ngStyle]="{'display':forgotpasswordmodeldisplay}"   id="forogtpassword" role="dialog" aria-modal="true" aria-labelledby="forgotpasswordLabel"
data-backdrop="static" data-keyboard="false">
<div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
        <div class="modal-header">
            <h6 class="modal-title" id="forgotpasswordLabel">Forgot Password</h6>
            <button type="button" id="forogtpassword" style="outline: none;"  (click)="forgotPasswordModelClose()"  class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="modal-body">
            <form class="" action="verification.html">
                <div class="form-row">
                    <div class="col-md-12 form-group d-flex justify-content-center">
                        <h2>Forgot password</h2>
                    </div>
                    <div class="col-md-12 form-group d-flex justify-content-center">
                      <h5>Enter your registered email to get password!!</h5>
                  </div>

                    <div class="col-md-12 form-group mt-5 mb-5">
                        <label for="exampleInputEmail1">Email</label>
                        <input type="email" class="form-control"  id="passwordemail" name="passwordemail" 
                        [(ngModel)]="passwordemail" autocomplete="off" placeholder="Email">
                        <div *ngIf="submit && passwordemail==''"><label class="validate-error">Email required*</label></div>
                        <div *ngIf="submit && passwordemail!='' && !validateEmail(passwordemail)"><label class="validate-error"> Invalid  Email</label></div>
                    </div>
                </div>
            </form>
        </div>
        <div class="modal-footer p-0 border-0">
            <div class="col-6 m-0 p-0">
                <button type="button" class="btn border-top btn-lg btn-block" (click)="forgotPasswordModelClose()" data-dismiss="modal">Close</button>
            </div>
            <div class="col-6 m-0 p-0">
                <button type="button" class="btn btn-primary btn-lg btn-block" style="box-shadow:none !important;" (click)="viewandSaveForgotPassword()">Save</button>
            </div>
        </div>
    </div>
</div>
</div>